import StoreService from "./store.service"
import Promise from "bluebird"

class TeamService {

  static _teams = null

  static init() {
    this.getCompetition()
  }

  static getCompetition() {
    this.competition = {};
    StoreService.store("competition").all()
      .then(competition => {
        //console.log(competition)
        this.competition = competition
      })
  }

  static getTeams() {
    if (! _.isNil(this._teams)) {
      if (typeof this._teams === 'Promise') {
        return this._teams
      } else {
        return Promise.resolve(this._teams); 
      }
    }
    this._teams = this.store().all()
      .tap(teams => this._teams = teams)
      //.tap(teams => this._teams = _.sortBy(_.cloneDeep(teams), t =>  _.indexOf(_.map(def, "name"), t.name)))
    return this._teams
  }

  static teams() {
    return _.get(this, "_teams", [])
  }

  static store() {
    if (_.isNil(this._store)) this._store = StoreService.store("team")
    return this._store
  }
  
  // static teamByEvent(event) {
  //   let result = _.find(this._teams, t => _.filter(t.events, e => _.includes(_.kebabCase(e.event), event) || _.includes(event, _.kebabCase(e.event))).length > 0)
  //   if (_.isNil(result)) {
  //     //challenge-anjou-seniors-poule-unique
  //     event = _.replace(_.replace(event, '-poule', ''), '-unique', '')
  //     result = _.find(this._teams, t => _.filter(t.events, e => _.includes(_.kebabCase(e.event), event) || _.includes(event, _.kebabCase(e.event))).length > 0)
  //   }
  //   return result;
  // }

  static teamByEvent(eventKey, result) {
    let key
    if (!_.includes(eventKey, "group")
      && !_.includes(eventKey, "poule")
      && !_.includes(eventKey, "ds")
      && !_.includes(eventKey, "u-13-f-p-2")
      && !_.includes(eventKey, "coupe")
      && !_.includes(eventKey, "challenge")
      && !_.includes(eventKey, "regional-2")
    ) return
    if (!key && !_.includes(eventKey, "matchs-amicaux")
      //&& !_.includes(eventKey, "regional-3-equipe-2")
      /*&& !_.includes(eventKey, "konica")*/
    ) {
      let isRegional = false
      let isDepartemental = false
      let isEquipe2 = false
      let isEquipe3 = false
      let isEquipe4 = false
      let isSenior = false
      let isCoupe = false
      let isChallenge = false
      let isGambardella = false
      let isLoire = false
      let isAnjou = false
      let isReserve = false
      let isU13 = false
      let isU15 = false
      let isU17 = false
      let isU19 = false
      let isFemal = false
      if (eventKey.includes("regional")) isRegional = true
      if (eventKey.includes("departemental")) isDepartemental = true
      if (eventKey.includes("equipe-2")) isEquipe2 = true
      if (eventKey.includes("equipe-3")) isEquipe3 = true
      if (eventKey.includes("equipe-4")) isEquipe4 = true
      if (eventKey.includes("senior")) isSenior = true
      if (eventKey.includes("coupe")) isCoupe = true
      if (eventKey.includes("challenge")) isChallenge = true
      if (eventKey.includes("gambardella")) isGambardella = true
      if (eventKey.includes("loire")) isLoire = true
      if (eventKey.includes("anjou")) isAnjou = true
      if (eventKey.includes("reserve")) isReserve = true
      if (eventKey.includes("u-13")) isU13 = true
      if (eventKey.includes("u-15")) isU15 = true
      if (eventKey.includes("u-17")) isU17 = true
      if (eventKey.includes("u-19")) isU19 = true
      if (eventKey.includes("-f-")) isFemal = true
      if (isRegional) key = "1-a"
      if (isCoupe && isLoire) key = "1-a"
      if (isCoupe && isAnjou & isSenior) key = "1-a"
      if (isDepartemental && isEquipe2) key = "1-b"
      if (isChallenge && isReserve) key = "1-b"
      if (isEquipe3) key = "1-c"
      if (isEquipe4) key = "1-d"
      if (isU13) key = "u-13-a"
      if (isU13 && isEquipe2) key = "u-13-b"
      if (isU13 && isFemal) key = "u-13-f"
      if (isU15) key = "u-15-a"
      if (isU15 && isEquipe2) key = "u-15-b"
      if (isU15 && isFemal) key = "u-15-f"
      if (isU15 && isFemal && isEquipe2) key = "u-15-f-2"
      /*if (isU15 && isFemal && isEquipe3) key = "u-15-f-3"*/
      if (isU17) key = "u-17-a"
      if (isU17 && isEquipe2) key = "u-17-b"
      if (isU19) key = "u-19-a"
      if (isGambardella) key = "u-19-a"
      console.log(key, eventKey)
      //if (!key && isDepartemental)
      //debugger;
      //team = {key, name, events: []};
      //this.teams_.push(team);

      const r = result
      if (r && key == "1-a") {
        if (r.eq1 == "ASSPM" && r.team1.includes("2")) key = "1-b"
        if (r.eq2 == "ASSPM" && r.team2.includes("2")) key = "1-b"
      }
      if (r && key == "u-13-a") {
        if (r.eq1 == "ASSPM" && r.team1.includes("2")) key = "u-13-b"
        if (r.eq2 == "ASSPM" && r.team2.includes("2")) key = "u-13-b"
      }
      if (r && key == "u-15-a") {
        if (r.eq1 == "ASSPM" && r.team1.includes("2")) key = "u-15-b"
        if (r.eq2 == "ASSPM" && r.team2.includes("2")) key = "u-15-b"
      }
      if (r && key == "u-15-f") {
        if (r.eq1 == "ASSPM" && r.team1.includes("2")) key = "u-15-f-2"
        if (r.eq2 == "ASSPM" && r.team2.includes("2")) key = "u-15-f-2"
      }
      if (r && key == "u-17-a") {
        if (r.eq1 == "ASSPM" && r.team1.includes("2")) key = "u-17-b"
        if (r.eq2 == "ASSPM" && r.team2.includes("2")) key = "u-17-b"
      }
      if (r && !key) {
        if (r.eq1 == "ASSPM" && r.team1.includes("3")) key = "1-c"
        if (r.eq2 == "ASSPM" && r.team2.includes("3")) key = "1-c"
        if (r.eq1 == "ASSPM" && r.team1.includes("4")) key = "1-d"
        if (r.eq2 == "ASSPM" && r.team2.includes("4")) key = "1-d"
      }

    }
    // let team = ""
    // _.each(this.competition, c => {
    //   _.each(c.events, e => {
    //     if (e.includes(competition)) {
    //       team = c.name
    //     }
    //   })
    // })
    // return team
    return key
  }

}

export default TeamService

export {TeamService}